import { Link } from "react-router-dom";

const FeatureCard = (props) => {
    return (
        <div className="w-[300px] hover:scale-95 transition-transform text-gray-900 dark:bg-bgDark dark:text-slate-300 rounded-lg border border-gray-200 dark:border-black shadow-md ">
            <Link to={props.link}>
                <img className="rounded-t-lg bg-[#242527]" src={props.image} alt="trade values" />
            </Link>
            <div className="p-5">
                <Link to={props.link}>
                    <h5 className="mb-2 text-2xl font-bold tracking-tight  ">{props.title}</h5>
                </Link>
                <p className="mb-3 font-normal  ">{props.description}</p>
                <Link to={props.link} className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-theme rounded-lg hover:bg-[#420BA1] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Read more
                    <svg aria-hidden="true" className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                </Link>
            </div>
        </div>
    );
}

export default FeatureCard;